export default "__VITE_ASSET__CH00KPGk__"